/**
 * Legacy ↔ canonical menu route aliases (Incident 15 / R32).
 * Keep in sync with backend/core/menu_route_aliases.py.
 */
export const RENAMED_MENU_ROUTE_ALIASES = {
  '/operations/field-operations': '/drilling/progress-map',
  '/operations/field-planning': '/drilling/work-planning',
  '/operations/drilling/work-projection': '/drilling/work-projection',
  '/operations/drilling/crew-report-field': '/drilling/crew-report-field',
  '/operations/drilling/sp-registry': '/drilling/sp-registry',
  '/operations/drilling/crew-reports': '/drilling/crew-reports',
  '/operations/drilling/npt-log': '/drilling/npt-log',
  '/operations/drilling/client-daily-report': '/drilling/client-daily-report',
  '/reports/cdr-archive': '/drilling/cdr-archive',
  '/reports/npt-report-archive': '/drilling/npt-report-archive',
  '/budgets/survey/new': '/budgets/survey',
  '/budgets/management?area=survey': '/budgets/survey',
  '/budgets/drilling/new': '/budgets/drilling',
  '/budgets/management?area=drilling': '/budgets/drilling',
  '/budgets/recording/new': '/budgets/recording',
  '/budgets/management?area=recording': '/budgets/recording',
  '/budgets/new': '/budgets/basecamp',
  '/budgets/management?area=basecamp': '/budgets/basecamp',
  // ETAPA 5a — dos pantallas se funden en una, asi que DOS rutas viejas
  // apuntan a la misma nueva. Sin esto, quien tenia concedida «Corporate
  // Personnel» perderia el acceso al Personnel unificado en silencio.
  '/hr/company/employees': '/hr/personnel',
  '/hr/project/team': '/hr/personnel',
  '/hr/timesheet/company': '/hr/timesheet/month',
  '/hr/timesheet': '/hr/timesheet/month',
};

/** Extra search keywords for Access Control (legacy names users still look for). */
export const MENU_SEARCH_ALIASES = {
  '/drilling/progress-map': ['field operations', 'field ops'],
  '/drilling/work-planning': ['field planning'],
};

export function routeAliasSet(route) {
  const aliases = new Set([route]);
  const canonical = RENAMED_MENU_ROUTE_ALIASES[route];
  if (canonical) aliases.add(canonical);
  Object.entries(RENAMED_MENU_ROUTE_ALIASES).forEach(([oldRoute, newRoute]) => {
    if (newRoute === route) aliases.add(oldRoute);
  });
  return aliases;
}

export function expandMenuRoutesWithAliases(routes) {
  const expanded = new Set(Array.isArray(routes) ? routes : []);
  Object.entries(RENAMED_MENU_ROUTE_ALIASES).forEach(([oldRoute, newRoute]) => {
    if (expanded.has(oldRoute)) expanded.add(newRoute);
    if (expanded.has(newRoute)) expanded.add(oldRoute);
  });
  return [...expanded];
}

export function hasMenuRouteWithAliases(allowedMenus, menuRoute) {
  if (!menuRoute || !Array.isArray(allowedMenus)) return false;
  if (allowedMenus.includes('all')) return true;
  const aliases = routeAliasSet(menuRoute);
  for (const route of aliases) {
    if (allowedMenus.includes(route)) return true;
  }
  return false;
}
